import React from 'react';
import cn from 'classnames';
import b_ from 'b_';
import { Link } from '../Link';
import { Text } from '../Text';
import './CompatibleProducts.scss';

const b = b_.lock('CompatibleProducts');

export const CompatibleProducts = ({
  className,
  heading,
  products,
  richProducts
}) => {
  if ((products && products.length) || (richProducts && richProducts.length)) {
    return (
      <div className={cn(b(), className)}>
        <Text className={b('cardHeading')} type='h2'>{heading}</Text>
        {(richProducts || []).map(({ name, path, subTitle }, i) => (
          <Link
            className={b('linkItem')}
            to={path}
            key={i}
          >
            {`${name} - ${subTitle}`}

          </Link>
        ))}
        {(products || []).map((product, i) => (
          <Text className={b('linkItem')} key={i}>{product}</Text>
        ))}
      </div>
    );
  }

  return null;
};
